export const activities = {
  title: "Atividades diárias",
  subtitle: "Um dia na Gándara",
  items: {
    personal: {
      title: "Trabalho pessoal",
      description: "Tempo dedicado ao desenvolvimento individual com materiais Montessori, permitindo que cada criança avance no seu próprio ritmo"
    },
    workshops: {
      title: "Oficinas e projetos",
      description: "Atividades dirigidas que promovem a criatividade, o trabalho em equipe e o aprendizado prático"
    },
    tutoring: {
      title: "Tutorias",
      description: "Momentos para o acompanhamento personalizado do progresso acadêmico e emocional"
    },
    assembly: {
      title: "Assembleia",
      description: "Espaço diário de conversação onde compartilhamos, refletimos e resolvemos conflitos em comunidade"
    },
    rest: {
      title: "Descanso e alimentação",
      description: "Pausas estruturadas para promover hábitos saudáveis e recarregar energias"
    },
    play: {
      title: "Brincadeira livre",
      description: "Tempo essencial para socialização, criatividade e desenvolvimento físico em ambientes naturais"
    }
  }
};
